export const PERSONAL_WORKSPACE_KEY = 'crowdex.desktop.personal-workspace';
export const WORKSPACE_KEY = 'crowdex.desktop.workspace';
